export default {
  questionAlternatives: [],
  questionAlternative: undefined,
};
